import { useState } from 'react';
import { FormControl, FormLabel, Stack, Box, VStack } from '@chakra-ui/react';
import { Field } from 'formik';
import FormikInput from 'components/forms/new/formikFormFields/NameField';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    formLabelStyling,
    stackSpacing,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';

const TextField = ({
    name,
    label,
    description,
    required,
    darkMode,
    walkthroughId,
    tooltip,
    placeholder = '',
    isReadOnly,
}) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        {label}{' '}
                        {required && (
                            <span style={{ color: '#e53e3e' }}>*</span>
                        )}
                    </FormLabel>
                    {description && (
                        <Box sx={descriptionStyling} maxWidth={250}>
                            {description}
                        </Box>
                    )}
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        width: '100%',
                        alignItems: 'flex-start',
                        paddingTop: '15px',
                    }}>
                    <VStack width="100%" alignItems="normal">
                        <Field
                            as={FormikInput}
                            name={name}
                            placeholder={placeholder}
                            isReadOnly={isReadOnly}
                            data-walkthroughid={walkthroughId}
                        />
                    </VStack>
                </Box>
                {isHovered && tooltip && (
                    <FieldToolTip
                        label={tooltip}
                        ariaLabel={`${name}-tip`}
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default TextField;
